import { render } from "./FrequencyWatchHos.vue?vue&type=template&id=3bf67414&ts=true"
import script from "./FrequencyWatchHos.ts?vue&type=script&lang=ts&external"
export * from "./FrequencyWatchHos.ts?vue&type=script&lang=ts&external"

import "./FrequencyWatchHos.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__